import React from "react";
import { FormConfiguration } from "../FormConfiguration";
import { FormRuntime } from "../FormRuntime";
import { TextFormControl } from "../Controls/Web/TextFormControl";
import { XTabContainer, XTabContainerTab, XTabContainerTabContent, XTabContainerTabHeader } from "./XTabContainer";
import { BorderStyle, TabOrientation } from "../Utilities/FormDesignConstants";
import { DefaultOnOff } from "../Utilities/DefaultOnOff";
import { StoryNode } from "../../CommonUI/StoryBook/StoryData";
import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";

function getUI(): { form: FormConfiguration; container: XTabContainer } {
    let ui = new FormConfiguration();
    let tabContainer = new XTabContainer();

    let tabContainerTab = new XTabContainerTab();

    tabContainer.overrideFormBorderSettings = DefaultOnOff.On;

    let tabContainerTabContent = new XTabContainerTabContent();
    let tabContainerTabHeader = new XTabContainerTabHeader();

    tabContainerTabHeader.title = "Test 1";
    tabContainerTab.setContent(tabContainerTabContent);
    tabContainerTab.setHeader(tabContainerTabHeader);

    let tabContainerTab2 = new XTabContainerTab();
    let tabContainerTabContent2 = new XTabContainerTabContent();
    let tabContainerTabHeader2 = new XTabContainerTabHeader();
    tabContainerTabHeader2.title = "Test 2";
    tabContainerTab2.setContent(tabContainerTabContent2);
    tabContainerTab2.setHeader(tabContainerTabHeader2);

    tabContainer.addTab(tabContainerTab);
    tabContainer.addTab(tabContainerTab2);

    ui.add(tabContainer);

    return { form: ui, container: tabContainer };
}

export const ContainerTabStories = [
    new StoryNode(
        () => {
            let ui = getUI();
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Tab Container",
        "Empty Tab",
    ),
    new StoryNode(
        () => {
            let ui = getUI();
            ui.container.add(new TextFormControl());
            ui.container.add(new TextFormControl());
            ui.container.add(new TextFormControl());
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Tab Container",
        "Control Tab Container",
    ),
    new StoryNode(
        () => {
            let ui = getUI();

            ui.container.selectedValue = "test2";

            ui.container.add(new TextFormControl());
            ui.container.add(new TextFormControl());
            ui.container.add(new TextFormControl());
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Tab Container",
        "Second Tab",
    ),
    new StoryNode(
        () => {
            let ui = getUI();
            ui.container.orientation = TabOrientation.Veritical;

            ui.container.add(new TextFormControl());
            ui.container.add(new TextFormControl());
            ui.container.add(new TextFormControl());
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Tab Container",
        "Vertical",
    ),
    new StoryNode(
        () => {
            let ui = getUI();
            ui.container.fullWidth = true;

            ui.container.add(new TextFormControl());
            ui.container.add(new TextFormControl());
            ui.container.add(new TextFormControl());
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Tab Container",
        "Full Width",
    ),
    new StoryNode(
        () => {
            let ui = getUI();
            ui.container.centered = true;

            ui.container.add(new TextFormControl());
            ui.container.add(new TextFormControl());
            ui.container.add(new TextFormControl());
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Tab Container",
        "Centered",
    ),
    new StoryNode(
        () => {
            let ui = getUI();
            ui.container.containerBorderColor = "red";
            ui.container.containerBorderRadius = 50;
            ui.container.containerBorderStyle = BorderStyle.Dashed;
            ui.container.containerBorderWidth = 10;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Tab Container",
        "Override Border",
    ),
    new StoryNode(
        () => {
            let ui = getUI();
            ui.container.interControlSpacing = 30;
            ui.container.innerMargin = 30;

            ui.container.add(new TextFormControl());
            ui.container.add(new TextFormControl());
            ui.container.add(new TextFormControl());
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Tab Container",
        "Override Spacing",
    ),
    new StoryNode(
        () => {
            let ui = getUI();
            ui.container.innerMarginTabHeader = 30;

            ui.container.add(new TextFormControl());
            ui.container.add(new TextFormControl());
            ui.container.add(new TextFormControl());
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Tab Container",
        "Header Margin",
    ),
    new StoryNode(
        () => {
            let ui = getUI();
            ui.container.defaultTabContentBackground = UIStyleConstants.GRAY_COLOR;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Tab Container",
        "Default Content Background",
    ),
    new StoryNode(
        () => {
            let ui = getUI();
            ui.container.defaultShowContentBorder = true;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Tab Container",
        "Default Content Border",
    ),
    new StoryNode(
        () => {
            let ui = getUI();
            ui.container.defaultShowContentBorder = true;
            ui.container.tabs[0].content!.overrideFormBorderSettings = DefaultOnOff.On;
            ui.container.tabs[0].content!.contentBorderWidth = 2;
            ui.container.tabs[0].content!.contentBorderColor = "red";
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Tab Container",
        "Override Content Border",
    ),
    new StoryNode(
        () => {
            let ui = getUI();
            ui.container.defaultShowContentBorder = true;
            ui.container.tabs[0].content!.innerMargin = 30;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Tab Container",
        "Override Content Inner Border",
    ),
    new StoryNode(
        () => {
            let ui = getUI();
            ui.container.defaultTabContentBackground = UIStyleConstants.GRAY_COLOR;
            ui.container.tabs[0].content!.contentBackgroundColor = UIStyleConstants.GRAY_LIGHT_COLOR;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Tab Container",
        "Override Content Background",
    ),
];
